export default "__VITE_ASSET__Bt7Zw19I__"